import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Column, CustomSelect, CustomButton } from './cardan-form-full.styles';

function CardanFormFull(_ref) {
  let {
    plateButton,
    submitButton,
    handleFieldChange
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["plateButton", "submitButton", "handleFieldChange"]);

  const spreadSelectOptions = (label, optionsList, currentValue) => {
    const options = Array.isArray(optionsList) ? optionsList.map(option => ({
      label: option == null ? void 0 : option.name,
      selected: (option == null ? void 0 : option.value) === currentValue,
      value: option == null ? void 0 : option.value
    })) : [];
    return [{
      label,
      selected: currentValue === '',
      value: '',
      isPlaceholder: true
    }, ...options];
  };

  const mappingSelect = ['brand', 'model', 'year', 'version'];
  return /*#__PURE__*/React.createElement(Form, {
    as: "form",
    "data-testid": "cardan-form"
  }, /*#__PURE__*/React.createElement(Row, null, mappingSelect.map(id => {
    const selectKey = `cardan-${id}`;
    const field = props[id];
    const selectOptions = spreadSelectOptions(field.label, field.options, field.value);
    return /*#__PURE__*/React.createElement(Column, {
      key: selectKey
    }, /*#__PURE__*/React.createElement(CustomSelect, {
      id: selectKey,
      options: selectOptions,
      onChange: value => handleFieldChange(id, value),
      disabled: field.disabled,
      "data-testid": selectKey
    }));
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, {
    sizeFraction: "0.25"
  }), /*#__PURE__*/React.createElement(Column, {
    sizeFraction: "0.25"
  }), /*#__PURE__*/React.createElement(Column, {
    sizeFraction: "0.25"
  }, plateButton.isAvailable && /*#__PURE__*/React.createElement(CustomButton, {
    variation: plateButton.variation || 'fill',
    border: plateButton.variation === 'outline',
    disabled: plateButton.disabled,
    onClick: plateButton.onClick,
    uppercase: false,
    size: "small",
    "data-testid": "cardan-form-button-plateButton"
  }, plateButton.label)), /*#__PURE__*/React.createElement(Column, {
    sizeFraction: "0.25"
  }, /*#__PURE__*/React.createElement(CustomButton, {
    variation: submitButton.variation || 'fill',
    border: submitButton.variation === 'outline',
    disabled: submitButton.disabled,
    onClick: submitButton.onClick,
    uppercase: false,
    size: "small",
    "data-testid": "cardan-form-button-submitButton"
  }, submitButton.label))));
}

const optionPropType = process.env.NODE_ENV !== "production" ? PropTypes.shape({
  name: PropTypes.string,
  value: PropTypes.string
}) : {};
const selectPropType = process.env.NODE_ENV !== "production" ? PropTypes.shape({
  label: PropTypes.string,
  options: PropTypes.arrayOf(optionPropType),
  value: PropTypes.string,
  disabled: PropTypes.bool
}) : {};
const buttonPropType = process.env.NODE_ENV !== "production" ? PropTypes.shape({
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  variation: PropTypes.oneOf(['fill', 'outline'])
}) : {};
process.env.NODE_ENV !== "production" ? CardanFormFull.propTypes = {
  plateButton: Object.assign({}, buttonPropType, {
    isAvailable: PropTypes.bool
  }),
  submitButton: buttonPropType,
  brand: selectPropType,
  model: selectPropType,
  year: selectPropType,
  version: selectPropType,
  handleFieldChange: PropTypes.func
} : void 0;
CardanFormFull.defaultProps = {
  plateButton: {
    disabled: false,
    isAvailable: true,
    onClick: null,
    label: 'Busca por placa',
    variation: 'outline'
  },
  submitButton: {
    disabled: false,
    onClick: null,
    label: 'Procurar',
    variation: 'fill'
  },
  brand: {
    label: 'Todas as marcas',
    options: [],
    value: '',
    disabled: false
  },
  model: {
    label: 'Todos os modelos',
    options: [],
    value: '',
    disabled: true
  },
  year: {
    label: 'Todos os anos',
    options: [],
    value: '',
    disabled: true
  },
  version: {
    label: 'Todas as versões',
    options: [],
    value: '',
    disabled: true
  },
  handleFieldChange: null
};
export default CardanFormFull;